import React from 'react';
import styles from 'components/ReportHeading/ReportHeading.module.css';

import commonStrings from 'resources/commonStrings';

function ReportsQueueHeader() {
  const headerClasses = `${styles['intro-text']} ${styles['column']} ${styles['width-12']} nwea-ds-v1-typography-body-copy-large`;
  return (
    <p className={headerClasses}>
      {commonStrings.queue.downloadViewPrintHeader}
      <br />
      {commonStrings.queue.removeAfter14DaysHeader}
    </p>
  );
}

export default ReportsQueueHeader;
